<!--
 * @Description: 教职工详情 党政职务
 * @Author: 张天伟
 * @Date: 2023-03-08 11:59:14
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:37:18
-->
<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="职务名称码" label-align="right" align="left" width="140px" span="2">{{item.zwmcm}}</el-descriptions-item>
      <el-descriptions-item label="职务名称" label-align="right" align="left" width="140px" span="2">{{item.zwmc}}</el-descriptions-item>
      <el-descriptions-item label="职务类别" label-align="right" align="left" width="140px" span="2">{{item.zwlbbt}}</el-descriptions-item>
      <el-descriptions-item label="职务分类" label-align="right" align="left" width="140px" span="2">{{item.zwfl}}</el-descriptions-item>
      <el-descriptions-item label="职务级别" label-align="right" align="left" width="140px" span="2">{{item.zwjbbt}}</el-descriptions-item>
      <el-descriptions-item label="任职日期" label-align="right" align="left" width="140px" span="2">{{item.rzrq}}</el-descriptions-item>
      <el-descriptions-item label="任职部门" label-align="right" align="left" width="140px" span="2">{{item.rzbm}}</el-descriptions-item>
      <el-descriptions-item label="任职方式" label-align="right" align="left" width="140px" span="2">{{item.rzfsbt}}</el-descriptions-item>
      <el-descriptions-item label="任职原因" label-align="right" align="left" width="140px" span="2">{{item.rzyy}}</el-descriptions-item>
      <el-descriptions-item label="任职文号" label-align="right" align="left" width="140px" span="2">{{item.rzwh}}</el-descriptions-item>
      <el-descriptions-item label="任职批准单位" label-align="right" align="left" width="140px" span="2">{{item.rzpzdw}}</el-descriptions-item>
      <el-descriptions-item label="职务变动类别" label-align="right" align="left" width="140px" span="2">{{item.zwbdlbbt}}</el-descriptions-item>
      <el-descriptions-item label="当前任职状况" label-align="right" align="left" width="140px" span="2">{{item.dqrzzkbt}}</el-descriptions-item>
      <el-descriptions-item label="职务排序" label-align="right" align="left" width="140px" span="2">{{item.zwpx}}</el-descriptions-item>
      <el-descriptions-item label="主管或从事的工作" label-align="right" align="left" width="140px" span="2">{{item.zghcsdgz}}</el-descriptions-item>
      <el-descriptions-item label="免职日期" label-align="right" align="left" width="140px" span="2">{{item.mzrq}}</el-descriptions-item>
      <el-descriptions-item label="免职方式" label-align="right" align="left" width="140px" span="2">{{item.mzfsbt}}</el-descriptions-item>
      <el-descriptions-item label="免职原因" label-align="right" align="left" width="140px" span="2">{{item.mzyybt}}</el-descriptions-item>
      <el-descriptions-item label="免职文号" label-align="right" align="left" width="140px" span="2">{{item.mzwh}}</el-descriptions-item>
      <el-descriptions-item label="免职批准单位" label-align="right" align="left" width="140px" span="2">{{item.mzpzdw}}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigongdangzhengzhiwu/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
